/* WPM loader Component 
Animation displays a loader, shows a number with a specified color
*/
import "./WPMLoader.css";
const WPMLoader = ({higher}) => {
    return (        
        <span>
        <div class={`lds-ring ${higher ? 'lds-ring-green' : 'lds-ring-red'}`}><div></div><div></div><div></div><div></div></div>        
        </span>
    )
}
export default WPMLoader;